export default "__VITE_ASSET__f278b47e__"